<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<div class="header-container">
  <h2 class="ml-2" style="margin-bottom: 0;">Non Sales Leads</h2>
</div>
<div class="row assigned-lead mb-3">
  <div class="col data-table">
    <div class="row ml-1">
      <div class="filter-button-group glassy">
        <div class="header">
          <div class="search-bar" [class.sidenav-toggled]="isFilterOpen">
            <div class="input-wrapper">
              <img [src]="bucketurl + '/images/search.png'" alt="Search Icon">
              <input type="text" [formControl]="searchInput" maxlength="60"
                (keypress)="restrictFirstLetterSpace($event)" placeholder="Name, Email ID, Phone number, Lead ID"
                (keyup)="searchLead($event)">
            </div>
            <div class="buttons ml-3">
              <button class="header-btn" (click)="openDateRangePicker()">
                <img style="width: 13px;margin-left: -5px;margin-right: 10px;"
                  [src]="bucketurl + '/images/calender.png'" alt="">Date Range
              </button>
              <button class="header-btn ml-3" (click)="toggleSidenav()" [ngClass]="{ 'clicked': isFilterOpen }">
                <img style="width: 16px;margin-left: -5px;margin-right: 10px;" alt=""
                  [src]="bucketurl + '/images/filter.png'" alt="">Filter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row date-display justify-content-end mb-2 mt-2 mr-2">
      <div class="col-auto styled-date-box">
        <span class="date-label-dash" *ngIf="startDate">From:</span> <span class="date-value-dash">{{startDate |
          date:'dd-MMM-yyyy'}}</span>
        <span class="date-label-dash" *ngIf="endDate">To:</span> <span class="date-value-dash">{{endDate |
          date:'dd-MMM-yyyy'}}</span>
      </div>
    </div>

    <div class="leads-table ml-2 mb-3">
      <table mat-table [dataSource]="dataSource" matSort class="mat-table" (matSortChange)="sortChange($event)">
        <ng-container matColumnDef="first_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let element">{{element?.first_name || '-'}} {{element?.middle_name || ''}} {{element?.last_name || ''}}</td>
        </ng-container>

        <ng-container matColumnDef="mobile">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone Number</th>
          <td mat-cell *matCellDef="let element">{{element?.mobile || '-'}}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email ID</th>
          <td mat-cell *matCellDef="let element" style="text-transform: lowercase;">{{element?.email || '-'}}</td>
        </ng-container>

        <!-- <ng-container matColumnDef="lead_status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let element"
            [ngClass]="{'re-engaged' : element?.lead_status?.toLowerCase() == 're-engaged'}">{{element?.lead_status ||
            '-'}}</td>
        </ng-container> -->

        <ng-container matColumnDef="current_stage.stage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Lead Stage</th>
          <td mat-cell *matCellDef="let element">{{element?.current_stage?.stage || '-'}}</td>
        </ng-container>
        <ng-container matColumnDef="lost_reason">
          <th mat-header-cell *matHeaderCellDef>Reason</th>
          <td mat-cell *matCellDef="let element">{{element?.current_stage?.non_sales_category ||
            element?.current_stage?.non_sales_category || '-'}}
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let element">
            {{
            element?.lead_type_id == 1
            ? ''
            : ['Answered', 'ANSWER'].includes(element?.call_status)
            ? element?.call_status
            : 'Missed Call'
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="service_booking_number">
          <th mat-header-cell *matHeaderCellDef>Service Booking Number</th>
          <td mat-cell *matCellDef="let element">{{element?.po_appnt_no || '-'}}</td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let element"><a class="action-link"
              (click)="slidingPanel.togglePanel(element)">Details</a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" style="text-align: center;padding: 20px 0;" colspan="7">No data found!
          </td>
        </tr>
      </table>

      <mat-paginator (page)="pageHandler($event)" [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
  <div class="col example-container">
    <mat-sidenav-container class="mr-3 mb-3">
      <mat-sidenav #sidenav mode="side" position="end" [opened]="false" (openedChange)="onSidenavToggle($event)">
        <div class="fixed-top">
          <mat-toolbar>
            <span>Filter</span>
            <ng-container *ngIf="filterCount > 0">
              <span class="clear-all-button" (click)="clearAllFilters()">Clear All</span> </ng-container>
          </mat-toolbar>
          <mat-nav-list>
            <mat-panel-title class="filter-applied">
              Filters Applied <span class="count"> {{filterCount}}</span>
            </mat-panel-title>
          </mat-nav-list>
        </div>
        <div class="scrollable-content">
          <mat-accordion #accordion="matAccordion" multi="false">
            <mat-expansion-panel *ngFor="let filter of filters" class="custom-expansion-panel"
              [ngClass]="{ 'highlight': filter.checked }">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ filter.label }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-container *ngIf="filter.key == 'leadType'">
                <mat-checkbox *ngFor="let data of leadType" [(ngModel)]="data.checked"
                  (click)="check($event, data, filter.key)"> {{data.lead_type}}</mat-checkbox>
              </ng-container>
              <ng-container *ngIf="filter.key == 'baseSource'">
                <mat-checkbox *ngFor="let data of baseSource" [(ngModel)]="data.checked" (change)="onBaseSelect()"
                  (click)="check($event, data, filter.key)"> {{data.base_lead_source}}</mat-checkbox>
              </ng-container>
              <ng-container *ngIf="filter.key == 'source'">
                <mat-checkbox *ngFor="let data of sourceList" [(ngModel)]="data.checked"
                  (change)="onSourceSelectManually()" (click)="check($event, data, filter.key)">
                  {{data.lead_source}}</mat-checkbox>
              </ng-container>
              <ng-container *ngIf="filter.key == 'subSource'">
                <mat-checkbox *ngFor="let data of subSource" [(ngModel)]="data.checked"
                  (click)="check($event, data, filter.key)"> {{data.lead_sub_source}}</mat-checkbox>
              </ng-container>
              <ng-container *ngIf="filter.key == 'stage'">
                <mat-checkbox *ngFor="let data of leadStage" [(ngModel)]="data.checked"
                  (click)="check($event, data, filter.key)"> {{data.lead_stage}}</mat-checkbox>
              </ng-container>
              <ng-container *ngIf="filter.key == 'productCategory'">
                <mat-checkbox *ngFor="let data of productCategory" [(ngModel)]="data.checked"
                  (change)="onCategorySelect()" (click)="check($event, data, filter.key)">
                  {{data.product_categories}}</mat-checkbox>
              </ng-container>
              <ng-container *ngIf="filter.key == 'productModel'">
                <mat-checkbox *ngFor="let data of productModel" [(ngModel)]="data.checked" (change)="onModelSelect()"
                  (click)="check($event, data, filter.key)"> {{data.model}}</mat-checkbox>
              </ng-container>
              <ng-container *ngIf="filter.key == 'productVariant'">
                <mat-checkbox *ngFor="let data of productVariant" [(ngModel)]="data.checked"
                  (change)="onVariantSelect()" (click)="check($event, data, filter.key)">
                  {{data.variant}}</mat-checkbox>
              </ng-container>
              <ng-container *ngIf="filter.key == 'productColor'">
                <mat-checkbox *ngFor="let data of productColor" [(ngModel)]="data.checked"
                  (click)="check($event, data, filter.key)"> {{data.color}}</mat-checkbox>
              </ng-container>
              <ng-container *ngIf="filter.key == 'uniqueReEngaged'">
                <mat-checkbox *ngFor="let data of uniqueReEngaged" [(ngModel)]="data.checked"
                  (click)="check($event, data, filter.key)"> {{data.lead_status}}</mat-checkbox>
              </ng-container>
              <ng-container *ngIf="filter.key == 'followUpDate'">
                <mat-form-field class="custom-date-picker" appearance="outline">
                  <mat-label>Start date</mat-label>
                  <input matInput [matDatepicker]="picker" readonly [(ngModel)]="followupStartDate"
                    (click)="picker.open()">
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="custom-date-picker" appearance="outline">
                  <mat-label>End date</mat-label>
                  <input matInput [matDatepicker]="picker2" readonly [(ngModel)]="followupEndDate"
                    (click)="picker2.open()">
                  <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
                <div class="d-flex justify-content-center mb-4">
                  <button class="btn white-btn mr-2" type="button" (click)="clearFollowUpDate()">Clear</button>
                  <button class="btn blue-btn" type="submit" (click)="applyFollowupDate()"> Apply</button>
                </div>
              </ng-container>
              <ng-container *ngIf="filter.key == 'missedCalls'">
                <mat-checkbox *ngFor="let data of missed" [(ngModel)]="data.checked"
                  (click)="check($event, data, filter.key)"> {{data.name}}</mat-checkbox>
              </ng-container>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-sidenav>
    </mat-sidenav-container>
  </div>
</div>



<app-details-panel #slidingPanel (change)="onPanelToggle($event)"></app-details-panel>

<ng-template #dateRangePicker>
  <h4 mat-dialog-title class="ml-3">
    Date Range
    <img class="close-button" mat-dialog-close src="/assets/images/close.png" alt="" (click)="reset()">
  </h4>
  <mat-dialog-content class="date-range-picker">
    <div class="date-range-picker__content">
      <div class="date-range-picker__sidebar">
        <button class="date-btn" mat-button class="sidebar-button" [class.selected]="selectedButton === 'today'"
          (click)="selectToday()">Today</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'last7'"
          (click)="selectLast7Days()">Last 7 days</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'last15'"
          (click)="selectLast15Days()">Last 15 days</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'last30'"
          (click)="selectLast30Days()">Last 30 days</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'thisMonth'"
          (click)="selectThisMonth()">This Month</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'custom'"
          (click)="selectCustom()">Custom</button>
      </div>
      <div class="date-range-picker__main" [ngClass]="{ 'isDateCustom': selectedButton != 'custom'}">
        <!-- <mat-calendar  #startCalendar [maxDate]="maxDate" [(selected)]="startDate" (selectedChange)="onStartDateChange($event)"></mat-calendar>
        <mat-calendar [maxDate]="maxDate" [(selected)]="endDate" (selectedChange)="onEndDateChange($event)"></mat-calendar> -->
        <mat-calendar (selectedChange)="selectedChange($event)" [maxDate]="maxDate" [selected]="dateRange"
          #startCalendar></mat-calendar>
      </div>
    </div>

    <div mat-dialog-actions class="d-flex justify-content-between align-items-center">
      <div class="date-display">
        <span class="date-label" *ngIf="startDate">From:</span> <span class="date-value">{{startDate |
          date:'dd-MMM-yyyy'}}</span>
        <span class="date-label ml-2" *ngIf="endDate">To:</span> <span class="date-value">{{endDate |
          date:'dd-MMM-yyyy'}}</span>
      </div>
      <div>
        <button #cancelButton class="btn white-btn mr-2" type="button" (click)="closeDialog()">Cancel</button>
        <button class="btn blue-btn" type="submit" (click)="applyDateRange()">Apply</button>
      </div>
    </div>
  </mat-dialog-content>
</ng-template>